import React, { FC, useContext } from 'react'
import ManageContext from '../../contexts/manage'
import Loading from '@kaidam/fc-frontend/src/components/system/Loading'

const LoadingWrapper: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const manage = useContext(ManageContext)

  if(manage.loading) {
    return (
      <Loading />
    )
  }

  return (
    <>
      { children }
    </>
  )
}

export default LoadingWrapper